<template>
  <div class="video-monitor">
    <div class="mainbox-title">
      <span class="title-font">{{ video.title }}</span>
    </div>
    <div class="video-box" style="height: calc(100% - 30px)">
      <!-- <video :id="id" :src="video.src" v-if="video.src.length > 0" width="100%" height="100%" autoplay controls allowfullscreen></video>
       -->
      <div
        :id="id"
        style="width: 100%; height: 100%; display: flex; flex-flow: column"
        v-if="video.src.length > 0"
      ></div>
      <div style="color: #fff; font-size: 14px" v-else>暂无视频链接</div>
    </div>
    <div class="btn-wrap">
      <div class="btn-camera select" title="抓拍" @click="capture">
        <i class="el-icon-camera" />
      </div>
      <div class="btn-camera select" title="回放" @click="playback">
        <i class="el-icon-refresh" />
      </div>
      <div class="pie" v-show="showBtn">
        <div class="direction-btn select direction-btn-1" @click="startYun(0)">
          <i class="el-icon-arrow-up" />
        </div>
        <div class="direction-btn select direction-btn-2" @click="startYun(4)">
          <i class="el-icon-arrow-up rotate-315" />
        </div>
        <div class="direction-btn select direction-btn-3" @click="startYun(2)">
          <i class="el-icon-arrow-left" />
        </div>
        <div class="direction-btn select direction-btn-4" @click="startYun(6)">
          <i class="el-icon-arrow-up rotate-225" />
        </div>
        <div class="direction-btn select direction-btn-5" @click="startYun(1)">
          <i class="el-icon-arrow-down" />
        </div>
        <div class="direction-btn select direction-btn-6" @click="startYun(7)">
          <i class="el-icon-arrow-up rotate-135" />
        </div>
        <div class="direction-btn select direction-btn-7" @click="startYun(3)">
          <i class="el-icon-arrow-right" />
        </div>
        <div class="direction-btn select direction-btn-8" @click="startYun(5)">
          <i class="el-icon-arrow-up rotate-45" />
        </div>
        <div class="center">
          <div class="center-btn select" @click="startYun(8)">
            <i class="el-icon-plus" />
          </div>
          <div class="center-btn select" @click="startYun(9)">
            <i class="el-icon-minus" />
          </div>
        </div>
      </div>
    </div>

    <el-dialog title :visible.sync="dialogVisible" top="60px" width="800px">
      <img style="width: 100%" :src="imgSrc" :title="imgTitle" />
    </el-dialog>

    <el-dialog
      title="录像回放"
      :visible.sync="playbackDialogVisible"
      top="60px"
      width="800px"
      @close="playbackDialogClose"
    >
      <div style="text-align: left">
        时间：
        <el-date-picker
          v-model="startTime"
          type="datetime"
          placeholder="开始时间"
        ></el-date-picker>
        <el-date-picker
          style="margin-left: 10px"
          v-model="endTime"
          type="datetime"
          placeholder="结束时间"
        ></el-date-picker>
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="loadPlayback"
          >查询</el-button
        >
      </div>
      <div
        style="padding-top: 20px; width: 700px; height: 500px; margin: 0px auto"
      >
        <div :id="id2"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs"; // 按需导入qs模块:post请求用到
import dateTool from "@/utils/dateTool.js";
import uuid from "uuid/v1";
import EZUIKit from "ezuikit-js";
export default {
  props: {
    video: {
      type: String,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      player: "",
      id: uuid(),
      accessToken: "",
      showBtn: false,
      dialogVisible: false,
      imgSrc: "",
      imgTitle: "",
      playbackDialogVisible: false,
      startTime: new Date().setDate(new Date().getDate() - 1),
      endTime: new Date(),
      loading: false,
      id2: uuid(),
      player2: "",
      playbackSrc: "",
    };
  },
  methods: {
    async getToken() {
      let vm = this;
      await axios
        .post(
          "https://open.ys7.com/api/lapp/token/get",
          qs.stringify({
            appKey: vm.video.appKey,
            appSecret: vm.video.appSecret,
          })
        )
        .then((res) => {
          if (res.data.code == 200) {
            vm.accessToken = res.data.data.accessToken;
            this.videoOpen();
          } else {
            vm.$message.error(res.data.msg);
          }
        });
    },
    startYun(direction) {
      let vm = this;
      axios
        .post(
          "https://open.ys7.com/api/lapp/device/ptz/start",
          qs.stringify({
            accessToken: vm.accessToken,
            deviceSerial: vm.video.cameraSerialNumber,
            channelNo: vm.video.channelNo,
            direction: direction,
            speed: 1,
          })
        )
        .then((res) => {
          if (res.data.code !== "200") {
            vm.$message.error(res.data.msg);
          } else {
            axios
              .post(
                "https://open.ys7.com/api/lapp/device/ptz/stop",
                qs.stringify({
                  accessToken: vm.accessToken,
                  deviceSerial: vm.video.cameraSerialNumber,
                  channelNo: vm.video.channelNo,
                  direction: direction,
                })
              )
              .then((obj) => {
                if (res.data.code !== "200") {
                  vm.$message.error(res.data.msg);
                }
              });
          }
        });
    },
    capture() {
      let vm = this;
      axios
        .post(
          "https://open.ys7.com/api/lapp/device/capture",
          qs.stringify({
            accessToken: vm.accessToken,
            deviceSerial: vm.video.cameraSerialNumber,
            channelNo: vm.video.channelNo,
          })
        )
        .then((res) => {
          if (res.data.code !== "200") {
            vm.$message.error(res.data.msg);
          } else {
            vm.imgTitle =
              vm.video.title +
              dateTool.format(new Date(), "yyyy-MM-dd hh:mm:ss") +
              "抓拍图片";
            vm.dialogVisible = true;
            vm.imgSrc = res.data.data.picUrl;
          }
        });
    },
    downloadCodeImg(url, imgTitle) {
      var image = document.createElement("img");
      image.crossOrigin = "Anonymous"; //解决跨域图片问题，就是上面提及的
      image.onload = function () {
        console.log("**********");
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        canvas
          .getContext("2d")
          .drawImage(image, 0, 0, image.width, image.height);
        canvas.toBlob((blob) => {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = imgTitle;
          link.click();
        }, "image/jpeg");
      };
      image.src = url;
    },
    videoOpen() {
      setTimeout(() => {
        this.player = new EZUIKit.EZUIKitPlayer({
          id: this.id,
          accessToken: this.accessToken,
          url: this.video.src,
          footer: ["hd", "fullScreen"],
          templete: "security",
        });
      }, 70);
    },
    playback() {
      let vm = this;
      vm.playbackDialogVisible = true;
      vm.loadPlayback();
    },
    playbackDialogClose() {
      let vm = this;
      if (vm.player2 != "") {
        vm.player2.stop();
      }
    },

    loadPlayback() {
      let vm = this;
      if (vm.player2 != "") {
        vm.player2.stop();
      }
      vm.playbackSrc =
        "ezopen://open.ys7.com/" +
        vm.video.cameraSerialNumber +
        "/" +
        vm.video.channelNo +
        ".rec?begin=" +
        dateTool.format(new Date(vm.startTime), "yyyyMMddhhmmss") +
        "&end=" +
        dateTool.format(new Date(vm.endTime), "yyyyMMddhhmmss");
      setTimeout(() => {
        vm.player2 = new window.EZUIPlayer({
          id: vm.id2,
          url: vm.playbackSrc,
          autoplay: true,
          accessToken: vm.accessToken,
          decoderPath: "/hikvision",
          width: 700,
          height: 500,
          splitBasis: 1,
        });
      }, 70);
    },
  },

  mounted() {
    if (this.video.src.length > 0) {
      if (this.video.appKey != "" && this.video.appSecret != "") {
        if (this.video.cameraType == "球形摄像头") {
          this.showBtn = true;
        }
        this.getToken();
      }
    }
  },

  beforeDestroy() {
    this.player.stop(); //关闭视频流
  },
};
</script>
<style lang="scss" scoped>
.video-monitor {
  height: 100%;
  background: #fff;
  position: relative;
}
.video-box {
  background: #212020;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mainbox-title {
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #f0f3f4;
  color: #000;
}
.btn-wrap {
  text-align: left;
  position: absolute;
  top: 80px;
  width: 120px;
  right: 0px;
}
.dialog-footer {
  text-align: right;
}

.pie {
  width: 120px;
  height: 120px;
  border-radius: 120px;
  background: #00000040;
  position: relative;
}
.center {
  position: absolute;
  left: 30px;
  top: 30px;
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 60px;
  background: #00000060;
  display: flex;
  align-items: center;
  justify-content: center;
  .center-btn {
    flex: 1;
    height: 100%;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
  }
}
.btn-camera {
  margin: 0px auto;
  width: 60px;
  height: 60px;
  font-size: 30px;
  border-radius: 60px;
  background: #00000060;
  text-align: center;
  line-height: 60px;
  margin-bottom: 20px;
}
.select {
  color: #dddbdb;
}
.select:hover {
  color: #ffffff;
  cursor: pointer;
}
.direction-btn {
  width: 30px;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  text-align: center;
  position: absolute;
}
.direction-btn-1 {
  top: 0px;
  left: 45px;
}
.direction-btn-2 {
  top: 15px;
  left: 10px;
}
.direction-btn-3 {
  top: 45px;
  left: 0px;
}
.direction-btn-4 {
  top: 75px;
  left: 15px;
}
.direction-btn-5 {
  top: 90px;
  left: 45px;
}
.direction-btn-6 {
  top: 75px;
  left: 75px;
}
.direction-btn-7 {
  top: 45px;
  left: 90px;
}
.direction-btn-8 {
  top: 10px;
  left: 75px;
}
.rotate-315 {
  transform: rotate(315deg);
  -ms-transform: rotate(315deg); /* IE 9 */
  -moz-transform: rotate(315deg); /* Firefox */
  -webkit-transform: rotate(315deg); /* Safari 和 Chrome */
  -o-transform: rotate(315deg); /* Opera */
}
.rotate-225 {
  transform: rotate(225deg);
  -ms-transform: rotate(225deg); /* IE 9 */
  -moz-transform: rotate(225deg); /* Firefox */
  -webkit-transform: rotate(225deg); /* Safari 和 Chrome */
  -o-transform: rotate(225deg); /* Opera */
}
.rotate-225 {
  transform: rotate(225deg);
  -ms-transform: rotate(225deg); /* IE 9 */
  -moz-transform: rotate(225deg); /* Firefox */
  -webkit-transform: rotate(225deg); /* Safari 和 Chrome */
  -o-transform: rotate(225deg); /* Opera */
}
.rotate-135 {
  transform: rotate(135deg);
  -ms-transform: rotate(135deg); /* IE 9 */
  -moz-transform: rotate(135deg); /* Firefox */
  -webkit-transform: rotate(135deg); /* Safari 和 Chrome */
  -o-transform: rotate(135deg); /* Opera */
}
.rotate-45 {
  transform: rotate(45deg);
  -ms-transform: rotate(45deg); /* IE 9 */
  -moz-transform: rotate(45deg); /* Firefox */
  -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
  -o-transform: rotate(45deg); /* Opera */
}

.play-list {
  display: flex;
  flex-wrap: wrap;
  width: 720px;
  height: 400px;
  overflow: auto;
  margin: 0px auto;

  justify-content: center;
  align-items: center;
}
.playback-item {
  position: relative;
  width: 160px;
  height: 160px;
  margin-top: 20px;
  margin-right: 20px;
  img {
    width: 100%;
    height: 100%;
  }
  .item-label {
    position: absolute;
    bottom: 0px;
    width: 160px;
    background: #00000080;
    color: #ffffff;
    padding: 6px 4px;
    box-sizing: border-box;
    word-break: break-all !important;
    word-wrap: break-word !important;
    text-align: left;
    white-space: pre-wrap;
    overflow: hidden;
  }
}
</style>